import React from "react";
import { FormGroup, FormControl, TextField, Grid } from "@material-ui/core";
import styled from "styled-components";
import FormHelperText from "../../forms/FormHelperText";

const ServiceCallURL = styled(TextField)`
  min-width: 475px;
  max-width: 600px;
`;

const ServiceCallErrorMessage = styled(TextField)`
  min-width: 475px;
  max-width: 600px;
`;

const ServiceCallCustomers = styled(TextField)`
  min-width: 475px;
  max-width: 600px;
`;

interface IAPIFieldsProps {
  onURLFieldChange: (url: string) => void;
  onErrorMessageFieldChange: (message: string) => void;
  onCustomersFieldChange: (customers: string) => void;
}

const ServiceCallAPIFields = (props: IAPIFieldsProps) => {
  const [description, setDescription] = React.useState("");

  const { onURLFieldChange, onErrorMessageFieldChange, onCustomersFieldChange } = props;

  const handleURLFieldChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    onURLFieldChange(event.target.value);
  };

  const handleErrorMessageFieldChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    onErrorMessageFieldChange(event.target.value);
  };

  const handleCustomersFieldChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    onCustomersFieldChange(event.target.value);
  };

  return (
    <>
      <Grid item>
        <FormControl component="fieldset">
          <FormGroup>
            <ServiceCallURL id="urls" label="URLs" variant="outlined" multiline={true} rows={2} rowsMax={100} onChange={handleURLFieldChange} />
          </FormGroup>
          <FormHelperText>Please record the full URLs of the requests, including all parameters. Separate each URL with an empty line.</FormHelperText>
        </FormControl>
      </Grid>
      <Grid item>
        <FormControl component="fieldset">
          <FormGroup>
            <ServiceCallErrorMessage
              id="errormessage"
              label="Error Message"
              variant="outlined"
              multiline={true}
              rows={4}
              rowsMax={100}
              onChange={handleErrorMessageFieldChange}
            />
          </FormGroup>
          <FormHelperText>Please copy/paste the full error message that was received.</FormHelperText>
        </FormControl>
      </Grid>
      <Grid item>
        <FormControl component="fieldset">
          <FormGroup>
            <ServiceCallCustomers id="customers" label="Affected Customers" variant="outlined" onChange={handleCustomersFieldChange} />
          </FormGroup>
          <FormHelperText>Please mention which customers were affected.</FormHelperText>
        </FormControl>
      </Grid>
    </>
  );
};

export default ServiceCallAPIFields;
